module.exports = __webpack_public_path__ + "static/media/71Pes5DjX2L._SL1500_.2c161e36.jpg";